import { BASE_URL, GET, REGULATORY_INFO } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchregulatoryInfo = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${REGULATORY_INFO}/${requestId}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
